"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusVisible = focusVisible;

var _styledComponents = require("styled-components");

function focusVisible(rules) {
  return (0, _styledComponents.css)([".js-focus-visible &:focus{outline:none;}&:focus-visible{", "}&:focus.focus-visible{", "}"], rules, rules);
}